// test1202
(1202 && 0);
